import { hasCapability, type User } from "../base";

export const verifyContractorCostsAutoComplete = {
  read: (user: User) => hasCapability(user, "verifyContractorCostsAutoComplete.read"),
  update: (user: User) => hasCapability(user, "verifyContractorCostsAutoComplete.update"),
};
